import React from "react";
import { FiX } from "react-icons/fi";
import contactUs from "../../Asset/subscription successfully icon.svg";
import { ReactSVG } from "react-svg";
import { NavLink } from "react-router-dom";

const SubscriptionPopUp = ({ isOpen, setIsOpen }) => {
  const onClose = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#000000A3] backdrop-blur-[1px] z-[200]">
      <div className="bg-white relative  rounded-3xl mt-[2.5rem] max-h-[90vh]   md:max-w-md w-[90%] mx-auto p-4 font-inter flex flex-col gap-4">
        <div className=" md:w-20 w-16 md:h-20 h-16 absolute md:-top-[2.5rem] -top-[2rem] left-1/2 -translate-x-1/2 bg-white rounded-full flex items-center justify-center">
          <div className=" flex items-center justify-center md:w-16 w-12 md:h-16 h-12 bg-[#D7EFFC] rounded-full">
            <ReactSVG
              src={contactUs}
              beforeInjection={(svg) => {
                svg.setAttribute("class", "md:w-8 w-6 h-auto");
              }}
              className="w-auto"
            />
          </div>
        </div>
        <div className=" flex w-full items-center justify-end">
          <FiX onClick={onClose} className="  text-black cursor-pointer" />
        </div>
        <div className=" w-full text-center font-jakarta lg:text-[1.78rem] md:text-[1.6rem] text-[1.2rem] mt-3 font-bold  text-black">
          You have successfully subscribed to{" "}
          <span className="bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] bg-clip-text text-transparent">
            Zero Typing Pro!
          </span>
        </div>
        <p className=" text-center w-full text-[#00000099] md:text-base text-sm font-medium ">
          Get ready to experience effortless speed and next-level
          <br className=" md:flex hidden" />
          automation. Let’s make every second count.
        </p>
        <NavLink
          to={"/download"}
          onClick={onClose}
          className=" text-white md:p-3 p-2.5 flex items-center justify-center w-full rounded-full bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] font-semibold text-[17px]"
        >
          Go to Application
        </NavLink>
      </div>
    </div>
  );
};

export default SubscriptionPopUp;
